"use client";
import { VikingLogo } from "@/components/icons/Logo";
import {
	NavigationMenuProvider,
	NavigationMenuRoot,
	NavigationMenuViewport,
} from "@/components/ui/NavigationMenu";
import { CartAmount } from "@/features/cart";
import { CartModalTrigger } from "@/features/cart/CartModal";

import { clsx } from "@frend-digital/ui";

import { Search } from "../Search";
import { AccountButton } from "./AccountIcon";
import styles from "./Header.module.css";
import type { BlokLink, BlokNavigationSection } from "@/storyblok";
import { MenuList } from "./MenuList";
import { usePathname } from "@/i18n/routing";
import { Chevron } from "@/components/icons/Chevron";
import { Translate } from "@/components/Translate";
import { Link } from "@/i18n/Link";

export const DesktopHeader = ({
	sections,
	preview,
}: {
	sections: (BlokNavigationSection | BlokLink)[];
	preview: boolean;
}) => {
	const pathname = usePathname();

	const isCheckout = pathname.includes("checkout") && !pathname.includes("summary");
	const firstFour = sections.slice(0, 4);
	const lastFour = sections.slice(4, sections.length);
	return (
		<NavigationMenuProvider>
			<NavigationMenuRoot delayDuration={15} className={styles.desktopMenu}>
				<div className={styles.inner}>
					{isCheckout ? (
						<Link href="/" className={styles.backButton}>
							<Chevron style={{ transform: "rotate(90deg)" }} />
							<span>
								<Translate>Back to store</Translate>
							</span>
						</Link>
					) : (
						<MenuList sections={firstFour} preview={preview} />
					)}

					<Link href="/">
						<VikingLogo className={styles.logo} height="28px" aria-label="Viking Footwear Logo" />
					</Link>

					{!isCheckout && (
						<MenuList sections={lastFour} preview={preview} className={clsx(styles.navListLast)}>
							<Search />

							<AccountButton />

							<CartModalTrigger asChild>
								<CartAmount />
							</CartModalTrigger>
						</MenuList>
					)}
				</div>
				<NavigationMenuViewport className={styles.viewport} />
			</NavigationMenuRoot>
		</NavigationMenuProvider>
	);
};
